<template>
  <v-form v-model="valid" style="font-family:Microsoft JhengHei;">
    <v-container md="12">
      <v-row dense>
        <v-col cols="12" md="8">
        <v-select :items="getCodeDateUtil('accountType')" label="使用者類別" dense v-model="editedItem.type" disabled></v-select>
        <v-checkbox v-model="editedItem.domain" v-if="editedItem.type === 'AAA'" label="是否有開設通譯培訓課程" disabled dense></v-checkbox>
        </v-col>
        <v-col cols="12" md="8" v-show="editedItem.type != 'CCC'" >
        <v-text-field v-model="editedItem.mainDeptId" label="機關代號或統一編號" disabled dense></v-text-field>
        </v-col>
        <v-col cols="12" md="8" v-show="editedItem.type != 'CCC'" >
        <v-text-field v-model="editedItem.mainDeptName" label="機關名稱" disabled dense></v-text-field>
        </v-col>
        <v-col cols="12" md="8" v-show="editedItem.type != 'CCC'" >
        <v-text-field v-model="editedItem.name" label="使用者姓名" disabled dense></v-text-field>
        </v-col>
        <v-col cols="12" md="8" v-show="editedItem.type === 'CCC'" >
        <v-text-field v-model="editedItem.name" label="姓名" disabled dense></v-text-field>
        </v-col>
        <v-col cols="12" md="8">
        <v-text-field 
          v-model="editedItem.account" 
          label="帳號" 
          type="text"
          :rules="nameRules"
          counter
          maxlength="20"
          class="font-weight-normal"
          :error-messages="txtAccountExists"
          v-on:change="checkAccount"
          dense></v-text-field>
        </v-col>
        <v-col cols="12" md="8">
        <v-text-field 
          id="password"
          label="密碼"
          :append-icon="showPassword1 ? 'visibility_off' : 'visibility'"
          :type="showPassword1 ? 'text' : 'password'"
          @click:append="showPassword1 = !showPassword1"
          v-model="pw"
          clearable
          counter
          maxlength="20"
          dense
          class="font-weight-normal"
          :rules="pwRules"
        ></v-text-field>
        </v-col>
        
        <v-col cols="12" md="8">
          <v-text-field
            id="password2"
            label="確認密碼"
            :append-icon="showPassword2 ? 'visibility_off' : 'visibility'"
            :type="showPassword2 ? 'text' : 'password'"
            @click:append="showPassword2 = !showPassword2"
            v-model="pw2"
            clearable
            required
            :rules="pw2Rules"
            counter
            maxlength="20"
            dense
            class="font-weight-normal"
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="8">
          <v-btn color="grey lighten-3" style="color:black;" @click="canceldata">清除</v-btn>
          <v-btn color="red" style="color:white;" class="ma-2" :disabled="(!valid)"  @click="savedata">確定</v-btn>
        </v-col>
      </v-row>
    </v-container>
  </v-form>
</template>
<script>
// import InterpreterDetail from "../Common/InterpreterDetail";
import swal from "sweetalert2";
import { mapGetters, mapActions } from "vuex";

export default {
  components: {
    // InterpreterDetail
  },
  computed: {
    ...mapGetters({
      getTargetCaseId: ["getTargetCaseId"],
      idbServerUrl: ["getIdbServerUrl"]
    }),
  },
  data() {
    return {
      valid: false,
      finalObject: [],
      ugrpIdArray: [],
      pw: null,
      pw2: null,
      showPassword1: false,
      showPassword2: false,
      accountExists: false,
      txtAccountExists: "",
      nameRules: [
        // v => !!v || "Name is required",
        v => !!v || "此欄位是必填",
        v => (v && v.length >= 6) || "必須大於6",
        v => (v && v.length <= 21) || "不能大於20"
      ],
      pwRules: [
        //  特殊符號 (?=.*[^a-zA-Z0-9])
        v => !!v || "此欄位是必填",
        v => (v && v.length >= 6) || "必須大於6",
        v => (v && v.length <= 21) || "不能大於20",
        v => /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d).{6,}$/.test(v) || "密碼強度需 6 位數以上，並且至少包含大寫字母、小寫字母、數字各一"
      ],
      pw2Rules: [
        v => !!v || "此欄位是必填",
        v => (v && v.length >= 6) || "必須大於6",
        v => (v && v.length <= 21) || "不能大於20",
        v => /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d).{6,}$/.test(v) || "密碼強度需 6 位數以上，並且至少包含大寫字母、小寫字母、數字各一",
        v => v === this.pw || "和密碼不相符"
      ],
      editedItem: null,
      userProfile: JSON.parse(this.$localStorage.get("userProfileStr")),
    };
  },
  watch: {
  },
  methods: {
    ...mapActions(["updateTargetCaseId"]),
    
    canceldata () {
      var vm=this;
      vm.pw = '';
      vm.pw2 = '';
      vm.showPassword1 = false;
      vm.showPassword2 = false;
      vm.editedItem.account = vm.userProfile.memberAccount.account;
      vm.accountExists=false;
      vm.txtAccountExists="";
    },
    savedata () {
      var vm = this;

      var objTmpUgrp={}
      vm.finalObject=[]
      if (vm.ugrpIdArray != null && vm.ugrpIdArray.length != 0) {
        for (var i = 0; i < vm.ugrpIdArray.length; i++) {
            objTmpUgrp = {
              roleId: vm.ugrpIdArray[i],
              targetId: vm.memberUuid
            };
            vm.finalObject.push(objTmpUgrp);
        }
      }

      if ( vm.pw != "" && vm.pw === vm.pw2) {
        vm.editedItem.password = vm.pw;
      }
      var data = {
        authRoleTargetList:vm.finalObject,
        memberAccount:vm.editedItem
      };

        vm.axios
          .put(vm.idbServerUrl + "idb/member/memberAccount", data, {
            headers: {
              "Content-Type": "application/json",
              Authorization: vm.$localStorage.get("idb_login_token")
            }
          })
          .then(function(response) {
            console.log("response\n" + JSON.stringify(response));
            vm.loginGo();
          })
          .catch(function(error) {
            vm.handErrorUtil(error);
            //console.log(error);
          });
    },


    checkAccount() {
      var vm = this;
      if (vm.editedItem.account.length>5 && vm.editedItem.account != vm.userProfile.memberAccount.account) {
        vm.axios
          .get(
            vm.idbServerUrl +
              "idb/member/isAccountExist/" + vm.editedItem.account,
            {
              headers: {
                "Content-Type": "application/json"
              }
            }
          )
          .then(function(response) {
            //console.log("response" + JSON.stringify(response.data));
            vm.accountExists=false;
            vm.txtAccountExists="";
            if (response.data.exist) {
              vm.accountExists=true;
              vm.txtAccountExists = "帳號重複，請重新設定";
            }
            //console.log("accountExists  " + vm.accountExists);
          })
          .catch(function(error) {
            vm.handErrorUtil(error);
            //console.log(error);
          });
      } else {
            vm.accountExists=false;
            vm.txtAccountExists="";
      }
    },

    loginGo() {
      swal({
        title: "請立即使用新密碼重新登入系統",
        type: "warning",
        allowOutsideClick: false,
        showConfirmButton: true
      });
      var vm = this;
      vm.$router.push({ path: "/Login" });
    },

    getInterpreterFromServer() {
      var vm = this;
      //console.log("memberAccount uuid 1\n" + vm.userProfile.memberAccount.uuid)
      vm.axios
        .get(
          vm.idbServerUrl +
            "idb/member/memberAccount/" + vm.userProfile.memberAccount.uuid,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: vm.$localStorage.get("idb_login_token")
            }
          }
        )
        .then(function(response) {
            vm.editedItem = response.data;
            //console.log("memberAccount uuid 2\n" + vm.userProfile.memberAccount.uuid)
            //console.log("editedItem \n" + JSON.stringify(vm.editedItem))
            vm.ugrpIdArray = [];
            vm.axios
              .get(
                vm.idbServerUrl + "idb/auth/AuthRoleTarget/" + vm.userProfile.memberAccount.uuid,
                {
                  headers: {
                    "Content-Type": "application/json",
                    Authorization: vm.$localStorage.get("idb_login_token")
                  }
                }
              )
              .then(function(response) {
                vm.items2 = response.data.resultList
                for (var i = 0; i < vm.items2.length; i++) {
                    vm.ugrpIdArray.push(vm.items2[i].roleId);
                }
                //console.log("ugrpIdArray \n" + JSON.stringify(vm.ugrpIdArray))
              })
              .catch(function(error) {
                vm.handErrorUtil(error.response.status);
              });
        })
        .catch(function(error) {
          vm.handErrorUtil(error);
          //console.log(error);
        });
    }
  
  },
  mounted() {
    var vm = this;
    vm.getInterpreterFromServer();
    vm.canceldata();
  }
};
</script>




